
import { Options, Vue } from "vue-class-component"; //基本需要
import SideMenu from "@/components/WorkBench/SideMenu.vue"; //导入组件SideMenu:1
import { getLocalProject, isJsonString, unique_json } from "@/utils";
import {
  dispatchGetProjectDetail,
  dispatchGetProjectScenes,
  dispatchGetProjectUsers,
  dispatchUpdateProject,
} from "@/store/project/actions";
import { store } from "@/store";
import {
  readMyProjects,
  readProjectDetail,
  readProjectScenes,
  readProjectUsers,
} from "@/store/project/getters";
import { IReportSettings } from "@/interfaces";
import { dispatchGetAllIndexes } from "@/store/main/actions";
import { readAllIndexes, readUserProfile } from "@/store/main/getters";
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import { readDeviceSpecs } from "@/store/device/getters";
import { ElMessage } from "element-plus";
import { special_projects } from "@/utils";
import { readGetCaseControl } from "@/store/performance/getters";
import { number } from "echarts/core";
// 导入组件SideMenu:2
@Options({
  components: {
    SideMenu,
  },
})
export default class ReportList extends Vue {
  // 声明属性
  public localProject = Number(getLocalProject()); //得到本地的项目
  public loading = false;
  public selectVisible = false;
  public itemaaas = [
    { type: "", label: "标签一" },
    { type: "", label: "标签二" },
    { type: "", label: "标签三" },
  ];
  public items = [
    "pagezhang(章平)",
    "v_baofeiyan(闫保飞)",
    "v_wenxikang(亢文禧)",
    "derosamei(梅维一)",
  ];
  public selected_device = { 0: 3, 1: 2, 2: 1 };
  public device_echart_options = [
    { label: "3档机 - huaweiplues - huawei" },
    { label: "2档机 - huaweiplues - huawei" },
    { label: "1档机 - huaweiplues - huawei" },
  ];
  public rule_settings: any = {
    change_rule: {
      increase_good: ["avg_fps"],
      threshold: {},
    },
    risk_rule: {},
    abs_risk_rule: {},
    tdr_risk_rule: {
      Android: {},
      iOS: {},
      PC: {},
    },
  };
  // 测试数据
  public testData = [
    "avg_fps",
    "loadingtime",
    "fps_lt_18_pcnt",
    "fps_lt_25_pcnt",
    "Var(FPS)",

    "FTime>=100[%]",

    "Jank(/10min)",

    "BigJank(/10min)",

    "Avg(Memory)[MB]",

    "max_pss",

    "monomem",

    "avg_monomem",

    "gc",

    "avg_dc",

    "Tris",

    "Verts",

    "UI_dc",

    "HUD_dc",

    "Scene_dc",
    "Particle_dc",
    "FrameSync",
    "LogicThr",
    "SleepTime",
    "PostTime",
    "avg_cpu",
    "max_cpu_temp",
  ];
  public testData1 = [
    { name: "avg_dc", threshold_type: "number", threshold_value: 3 },
    { name: "avg_monomem", threshold_type: "number", threshold_value: 3 },
    { name: "gc", threshold_type: "number", threshold_value: 3 },
  ];
  public scene_id = 9999;
  public report_settings: IReportSettings = {
    content: {
      core_index: [], //核心指数
      trend_index: [], //趋势指数
      exclude_scene: [], //排除场景
      exclude_device: [], //排除设备
      core_scene: [],
      trend_scene: [],
      show_index: [], //显示指标
      index_type: {
        //指标类型
        basic: [], //基础指标
        advance: [], //深度指标
        customize: [], //定制指标
      },
      trend_number: 10, // 趋势图的版本数
      trend_integrity: true, //趋势图完整性，是否允许有缺失数据
      is_have_old: true,
      red_only_change_value: false, // 核心表是否只标红括号内变化值
      core_color_rule: false,
    },
    notify: {
      //通知
      email: {
        enable: false,
        receiver_str: "", // 接收人列表转字符串，用 ";" 拼接
        receiver: [], //接收
      },
      wecom: {
        enable: false,
        receiver_str: "",
        receiver: [],
      },
      wecom_robot: {
        enable: false,
        receiver: [],
        receiver_str: "",
      },
    },
    common_aov: {
      increase_good: [],
    },
    custom: {},
    aov: {},
    aov_3: {},
    top: {
      risk_rule: {
        Android: {
          level_1: {
            avg_cpu: {
              risk_value: { high: 2, middle: 10 },
              value: 60,
            },
          },
          level_2: {
            avg_cpu: {
              risk_value: { high: 2, middle: 10 },
              value: 60,
            },
          },
          level_3: {
            avg_cpu: {
              risk_value: { high: 2, middle: 10 },
              value: 60,
            },
          },
        },
      },
    },
    // tdr_risk_rule:{}
  };
  public aovList: any = {};
  public checked1 = true;
  public form = "";
  public aov: any = []; //测试结论阈值指标
  public aov1: any = []; //默认结论阈值指标
  public aov3: any = []; //测试三轮对比阈值
  public aov4: any = []; //默认测试三轮对比阈值
  public coreIndex: any = []; //核心指标
  public trendIndex: any = []; //趋势指标
  public firstModel: any = []; //一档机型
  public secondModel: any = []; //一档机型
  public thirdModel: any = []; //一档机型
  public excludeScene: any = []; //屏蔽场景
  public excludeDevice: any = []; //屏蔽设备
  public Threshold: any = []; //指标变化标记阈值
  public flag: boolean[] = []; //正则判断
  //指标变化标记阈值输入内容
  public Threshold_input_value: any = {
    max_pss: 0,
    avg_fps: 0,
    fps_lt_10_pcnt: 0,
    fps_lt_18_pcnt: 0,
    fps_lt_25_pcnt: 0,
    fps_lt_40_pcnt: 0,
    avg_cpu: 0,
    cpu_lt_60_pcnt: 0,
    avg_flow: 0,
    dps: 0,
    max_vss: 0,
    lag_pcnt: 0,
    max_mono_total: 0,
    max_triangle: 0,
    max_dc: 0,
    gc_cnt: 0,
  };
  public riskRule: any = []; //风险评估阈值
  // public
  public Basic: any = []; //基础指标
  public Advance: any = []; //深度指标
  public Customize: any = []; //定制指标
  public riskRule_input_value: any = {};
  // 提交提示
  public Tips = [
    {
      tips: "该操作会覆盖该项目所属任务的报告设置，确定覆盖？",
      confirm: 2,
      title: "提交并应用于任务",
      Tips:
        '<p style="width: 200px;">提交后，任务完成生成的报告，使用该配置。不影响历史报告。</p>',
    },
    {
      tips: "该操作会将当前设置应用到该项目报告，确定应用？",
      confirm: 1,
      title: "提交并应用于现有报告",
      Tips:
        '<p style="width: 200px;">提交后,所有历史报告，和后面手动创建的报告，都使用该配置。自动生成的报告，不采用该配置，采用任务里面的报告配置。</p>',
    },
    {
      tips: "该操作会保存当前设置内容，下次手动新建报告和任务时生效，确定保存",
      confirm: false,
      title: "提交",
      Tips:
        '<p style="width: 200px;">提交后，后面手动创建的报告，都使用该配置。不包括历史报告，自动生成的报告</p>',
    },
  ];
  public visible = false;
  // 页面初始化
  public async mounted() {
    // console.log(this.getFirstModel)
    this.loading = true;
    dispatchGetProjectUsers(store, this.localProject);
    await dispatchGetAllIndexes(store, { project: this.localProject });
    await dispatchGetProjectDetail(store, {
      id: this.localProject,
      project: this.localProject,
    });
    await dispatchGetDeviceSpecs(store, { project: this.localProject });
    await dispatchGetProjectScenes(store, { project: this.localProject });
    this.get_project(); // 读取配置
    this.report_settings.content.is_have_old =
      this.report_settings.content.is_have_old == undefined
        ? true
        : this.report_settings.content.is_have_old;
    // await this.dataConversion(this.rule_settings.risk_rule);
    await this.dataConversion(this.rule_settings.change_rule.threshold);
    await this.getriskRule;

    await this.gettdrZeroModel;
    await this.gettdrPcModel;
    await this.gettdrPcFirstModel;
    await this.gettdrPcSecondModel;
    await this.gettdrPcThirdModel;
    await this.gettdrPcFourthModel;
    await this.gettdrZeroModel;
    await this.gettdrPcModel1(this.scene_id);
    await this.gettdrPcFirstModel1(this.scene_id);
    await this.gettdrPcSecondModel1(this.scene_id);
    await this.gettdrPcThirdModel1(this.scene_id);
    await this.gettdrPcFourthModel1(this.scene_id);
    await this.gettdrZeroModel1(this.scene_id);
    await this.gettdrFirstModel1(this.scene_id);
    await this.gettdrSecondModel1(this.scene_id);
    await this.gettdrThirdModel1(this.scene_id);
    await this.gettdrFourthModel1(this.scene_id);
    await this.gettdrIosFirstModel1(this.scene_id);
    await this.gettdrIosSecondModel1(this.scene_id);
    await this.gettdrIosThirdModel1(this.scene_id);
    await this.gettdrIosZeroModel1(this.scene_id);
    await this.gettdrIosfourthModel1(this.scene_id);
    await this.gettdrFirstModel;
    await this.gettdrSecondModel;
    await this.gettdrFourthModel;
    await this.gettdrThirdModel;
    await this.getThreshold;
    await this.gettdrIosFirstModel;
    await this.gettdrIosSecondModel;
    await this.gettdrIosThirdModel;
    await this.gettdrIosZeroModel;
    await this.gettdrIosfourthModel;
    await this.getaov;
    await this.getaov1;
    await this.getaov3;
    await this.getaov4;
    if (this.topShow) {
      await this.getFirstModel;
      await this.getsecondModel;
      await this.getthirdModel;
      // for(let obj in this.report_settings.top.risk_rule.Android.level_1){
      //   console.log(this.report_settings.top.risk_rule.Android.level_1[obj])
      //   this.report_settings.top.risk_rule.Android.level_1[obj]=this.report_settings.top.risk_rule.Android.level_1[obj].value+';'+this.report_settings.top.risk_rule.Android.level_1[obj].risk_value.middle+';'+this.report_settings.top.risk_rule.Android.level_1[obj].risk_value.high
      // }
      // for(let obj in this.report_settings.top.risk_rule.Android.level_2){
      //   console.log(this.report_settings.top.risk_rule.Android.level_2[obj])
      //   this.report_settings.top.risk_rule.Android.level_2[obj]=this.report_settings.top.risk_rule.Android.level_2[obj].value+';'+this.report_settings.top.risk_rule.Android.level_2[obj].risk_value.middle+';'+this.report_settings.top.risk_rule.Android.level_2[obj].risk_value.high
      // }
      // for(let obj in this.report_settings.top.risk_rule.Android.level_3){
      //   console.log(this.report_settings.top.risk_rule.Android.level_3[obj])
      //   this.report_settings.top.risk_rule.Android.level_3[obj]=this.report_settings.top.risk_rule.Android.level_3[obj].value+';'+this.report_settings.top.risk_rule.Android.level_3[obj].risk_value.middle+';'+this.report_settings.top.risk_rule.Android.level_3[obj].risk_value.high
      // }
      await this.modelList(this.report_settings.top.risk_rule.Android.level_1);
      await this.modelList(this.report_settings.top.risk_rule.Android.level_2);
      await this.modelList(this.report_settings.top.risk_rule.Android.level_3);
    }

    // console.log(this.report_settings.top.risk_rule.Android)
    await this.aovNewList(this.report_settings.aov);
    await this.aovNewList(this.report_settings.aov_3);

    this.loading = false;
  }
  // 判断是否是管理员
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.localProject
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }
  // 数据过滤显示
  public modelList(array: any) {
    for (let obj in array) {
      array[obj] =
        array[obj].value +
        ";" +
        array[obj].risk_value.middle +
        ";" +
        array[obj].risk_value.high;
    }
  }
  public get forVal() {
    const for_val = [
      {
        for_val: this.report_settings.content.core_index,
        close_val: "core_index",
        option_val: this.get_all_indexes,
      },
      {
        for_val: this.report_settings.content.core_index,
        close_val: "trend_index",
        option_val: this.get_all_indexes,
      },
    ];

    return for_val;
  }
  // 验证
  public verification(item: any, array: any) {
    item.forEach((item: any) => {
      var match = String(array[item]).match(/-?\d+[.]?\d*%?/g);

      this.flag.push(array[item] == match);
    });
  }
  // 验证机型测试设置
  public verification1(v: any, array: any) {
    let reg = new RegExp("^[0-9]*$");
    v.forEach((v: any) => {
      this.flag.push(reg.test(array[v].replace(/;/g, "")));
    });
  }
  // 还原数据机型设置数据结构

  public aovNewList(array: any) {
    for (let obj in array) {
      if (array[obj].threshold_type === "number") {
        array[obj] = String(array[obj].threshold_value);
      } else if (array[obj].threshold_type === "percent") {
        array[obj] = String(array[obj].threshold_value + "%");
      }
    }
  }
  // 转数字
  public convertNumbers(numObj: any) {
    for (let obj in numObj) {
      numObj[obj] = Number(numObj[obj]);
    }
  }
  public aow_new_model_value(array: any) {
    let value: any = {};
    value.risk_value = {};
    for (let obj in array) {
      let newObj = array[obj].split(";");

      value.value = Number(newObj[0]);

      value.risk_value.middle = Number(newObj[1]);
      value.risk_value.high = Number(newObj[2]);

      array[obj] = JSON.parse(JSON.stringify(value));

      // let value:any={};
      // for(let obj in array){
      //  value[obj]={}
      //   value[obj].risk_value={}
      // // let newObj=array[obj].split(";")

      // value[obj].value=array[obj].split(";")[0]

      // value[obj].risk_value.middle=array[obj].split(";")[1]
      // value[obj].risk_value.high=array[obj].split(";")[2]
      // value=array
      // console.log(array)
      // console.log(value)
    }
  }
  // 风险评估阈值
  public get getriskRule() {
    const riskRuleArray: any = this.rule_settings.risk_rule;
    // console.log(riskRuleArray)
    for (let item in riskRuleArray) {
      this.riskRule.push(item);
    }

    // console.log(this.riskRule)
    // this.riskRule.forEach((item: any)=>{
    //   console.log(riskRuleArray[item])
    //     var match = riskRuleArray[item].match(/-?\d+[.]?\d*%?/g);
    //     console.log(riskRuleArray[item]==match)
    //     console.log(match)

    // })
    return this.riskRule;
  }

  public tdrZeroModel: any = [];
  public get gettdrZeroModel() {
    if (this.rule_settings.tdr_risk_rule.Android.level_0 == undefined) {
      this.rule_settings.tdr_risk_rule.Android.level_0 = {
        avg_fps: "",
        max_pss: "",
      };
      const tdrRuleArray: any = this.rule_settings.tdr_risk_rule.Android
        .level_0;
      for (let item in tdrRuleArray) {
        this.tdrZeroModel.push(item);
      }
    } else {
      const tdrRuleArray: any = this.rule_settings.tdr_risk_rule.Android
        .level_0;
      for (let item in tdrRuleArray) {
        this.tdrZeroModel.push(item);
      }
    }

    return this.tdrZeroModel;
  }
  public tdrPcZeroModel: any = [];
  public get gettdrPcModel() {
    console.log(this.rule_settings.tdr_risk_rule);
    if (this.rule_settings.tdr_risk_rule.PC?.level_0 == undefined) {
      this.rule_settings.tdr_risk_rule.PC.level_0 = {
        avg_fps: "",
        max_pss: "",
      };
      const tdrRuleArray: any = this.rule_settings.tdr_risk_rule.PC.level_0;
      for (let item in tdrRuleArray) {
        this.tdrPcZeroModel.push(item);
      }
    } else {
      const tdrRuleArray: any = this.rule_settings.tdr_risk_rule.PC.level_0;
      for (let item in tdrRuleArray) {
        this.tdrPcZeroModel.push(item);
      }
    }

    return this.tdrPcZeroModel;
  }
  public tdrZeroModel1: any = [];
  public gettdrZeroModel1(scene: any) {
    if (scene != 9999) {
      if (this.rule_settings.tdr_risk_rule[scene] == undefined) {
        this.rule_settings.tdr_risk_rule[scene] = {};
        this.rule_settings.tdr_risk_rule[scene].Android = {};
        this.rule_settings.tdr_risk_rule[scene].Android.level_0 = JSON.parse(
          JSON.stringify(this.rule_settings.tdr_risk_rule.Android.level_0)
        );
      }
      let tdrRuleArray = [];
      tdrRuleArray = this.rule_settings.tdr_risk_rule[scene]?.Android?.level_0;
      this.convertNumbers(tdrRuleArray);

      this.tdrZeroModel1 = [];
      for (let item in tdrRuleArray) {
        this.tdrZeroModel1.push(item);
      }
    }
    return this.tdrZeroModel1;
  }
  public tdrPcZeroModel1: any = [];
  public gettdrPcModel1(scene: any) {
    if (scene != 9999) {
      if (this.rule_settings.tdr_risk_rule[scene].PC == undefined) {
        this.rule_settings.tdr_risk_rule[scene].PC = {};
        this.rule_settings.tdr_risk_rule[scene].PC.level_0 = JSON.parse(
          JSON.stringify(this.rule_settings.tdr_risk_rule.PC.level_0)
        );
      }

      let tdrRuleArray = [];
      tdrRuleArray = this.rule_settings.tdr_risk_rule[scene]?.PC?.level_0;

      this.convertNumbers(tdrRuleArray);
      this.tdrPcZeroModel1 = [];
      for (let item in tdrRuleArray) {
        this.tdrPcZeroModel1.push(item);
      }
    }
    return this.tdrPcZeroModel1;
    // if (scene != 9999) {
    //   if (this.rule_settings.tdr_risk_rule.PC== undefined) {
    //     this.rule_settings.tdr_risk_rule.PC = {};
    //     this.rule_settings.tdr_risk_rule[scene].PC = {};
    //     this.rule_settings.tdr_risk_rule[scene].PC.level_0 = JSON.parse(
    //       JSON.stringify(this.rule_settings.tdr_risk_rule.PC.level_0)
    //     );
    //   }
    //   let tdrRuleArray = [];
    //   tdrRuleArray = this.rule_settings.tdr_risk_rule[scene]?.PC?.level_0;
    //   this.convertNumbers(tdrRuleArray);

    //   this.tdrPcZeroModel1 = [];
    //   for (let item in tdrRuleArray) {
    //     this.tdrPcZeroModel1.push(item);
    //   }
    // }
    // return this.tdrPcZeroModel1;
  }
  public tdrFirstModel1: any = [];
  public gettdrFirstModel1(scene: any) {
    if (scene != 9999) {
      if (
        this.rule_settings.tdr_risk_rule[scene].Android.level_1 == undefined
      ) {
        this.rule_settings.tdr_risk_rule[scene].Android.level_1 = JSON.parse(
          JSON.stringify(this.rule_settings.tdr_risk_rule.Android.level_1)
        );
      }

      let tdrRuleArray1 = [];
      tdrRuleArray1 = this.rule_settings.tdr_risk_rule[scene]?.Android?.level_1;
      this.convertNumbers(tdrRuleArray1);

      this.tdrFirstModel1 = [];
      for (let item in tdrRuleArray1) {
        this.tdrFirstModel1.push(item);
      }
    }
    console.log(this.tdrZeroModel1);
    return this.tdrZeroModel1;
  }
  public tdrPcFirstModel1: any = [];
  public gettdrPcFirstModel1(scene: any) {
    if (scene != 9999) {
      if (this.rule_settings.tdr_risk_rule[scene]?.PC.level_1 == undefined) {
        this.rule_settings.tdr_risk_rule[scene].PC.level_1 = JSON.parse(
          JSON.stringify(this.rule_settings.tdr_risk_rule.PC.level_1)
        );
      }
      let tdrRuleArray = [];
      tdrRuleArray = this.rule_settings.tdr_risk_rule[scene]?.PC?.level_1;
      this.tdrPcFirstModel1 = [];
      this.convertNumbers(tdrRuleArray);
      for (let item in tdrRuleArray) {
        this.tdrPcFirstModel1.push(item);
      }
    }
    return this.tdrPcFirstModel1;
  }
  public tdrSecondModel1: any = [];
  public gettdrSecondModel1(scene: any) {
    if (scene != 9999) {
      if (
        this.rule_settings.tdr_risk_rule[scene].Android.level_2 == undefined
      ) {
        this.rule_settings.tdr_risk_rule[scene].Android.level_2 = JSON.parse(
          JSON.stringify(this.rule_settings.tdr_risk_rule.Android.level_2)
        );
      }
      let tdrRuleArray = [];
      tdrRuleArray = this.rule_settings.tdr_risk_rule[scene]?.Android?.level_2;
      this.convertNumbers(tdrRuleArray);
      this.tdrSecondModel1 = [];
      for (let item in tdrRuleArray) {
        this.tdrSecondModel1.push(item);
      }
    }
    return this.tdrSecondModel1;
  }
  public tdrPcSecondModel1: any = [];
  public gettdrPcSecondModel1(scene: any) {
    if (scene != 9999) {
      if (this.rule_settings.tdr_risk_rule[scene]?.PC.level_2 == undefined) {
        this.rule_settings.tdr_risk_rule[scene].PC.level_2 = JSON.parse(
          JSON.stringify(this.rule_settings.tdr_risk_rule.PC.level_2)
        );
      }
      let tdrRuleArray = [];
      tdrRuleArray = this.rule_settings.tdr_risk_rule[scene]?.PC?.level_2;
      this.tdrPcSecondModel1 = [];
      this.convertNumbers(tdrRuleArray);
      for (let item in tdrRuleArray) {
        this.tdrPcSecondModel1.push(item);
      }
    }
    return this.tdrPcSecondModel1;
  }
  public tdrThirdModel1: any = [];
  public gettdrThirdModel1(scene: any) {
    if (scene != 9999) {
      if (
        this.rule_settings.tdr_risk_rule[scene].Android.level_3 == undefined
      ) {
        this.rule_settings.tdr_risk_rule[scene].Android.level_3 = JSON.parse(
          JSON.stringify(this.rule_settings.tdr_risk_rule.Android.level_3)
        );
      }
      let tdrRuleArray = [];
      tdrRuleArray = this.rule_settings.tdr_risk_rule[scene]?.Android?.level_3;
      this.tdrThirdModel1 = [];
      this.convertNumbers(tdrRuleArray);
      for (let item in tdrRuleArray) {
        this.tdrThirdModel1.push(item);
      }
    }
    return this.tdrThirdModel1;
  }
  public tdrPcThirdModel1: any = [];
  public gettdrPcThirdModel1(scene: any) {
    if (scene != 9999) {
      if (this.rule_settings.tdr_risk_rule[scene]?.PC.level_3 == undefined) {
        this.rule_settings.tdr_risk_rule[scene].PC.level_3 = JSON.parse(
          JSON.stringify(this.rule_settings.tdr_risk_rule.PC.level_3)
        );
      }
      let tdrRuleArray = [];
      tdrRuleArray = this.rule_settings.tdr_risk_rule[scene]?.PC?.level_3;
      this.tdrPcThirdModel1 = [];
      this.convertNumbers(tdrRuleArray);
      for (let item in tdrRuleArray) {
        this.tdrPcThirdModel1.push(item);
      }
    }
    return this.tdrPcThirdModel1;
  }
  public tdrFourthModel1: any = [];
  public gettdrFourthModel1(scene: any) {
    if (scene != 9999) {
      if (
        this.rule_settings.tdr_risk_rule[scene].Android.level_4 == undefined
      ) {
        this.rule_settings.tdr_risk_rule[scene].Android.level_4 = JSON.parse(
          JSON.stringify(this.rule_settings.tdr_risk_rule.Android.level_4)
        );
      }
      let tdrRuleArray = [];
      tdrRuleArray = this.rule_settings.tdr_risk_rule[scene]?.Android?.level_4;
      this.tdrFourthModel1 = [];
      this.convertNumbers(tdrRuleArray);
      for (let item in tdrRuleArray) {
        this.tdrFourthModel1.push(item);
      }
    }
    return this.tdrFourthModel1;
  }
  public tdrPcFourthModel1: any = [];
  public gettdrPcFourthModel1(scene: any) {
    if (scene != 9999) {
      if (this.rule_settings.tdr_risk_rule[scene].PC.level_4 == undefined) {
        this.rule_settings.tdr_risk_rule[scene].PC.level_4 = JSON.parse(
          JSON.stringify(this.rule_settings.tdr_risk_rule.PC.level_4)
        );
      }
      let tdrRuleArray = [];
      tdrRuleArray = this.rule_settings.tdr_risk_rule[scene]?.PC?.level_4;
      this.tdrPcFourthModel1 = [];
      this.convertNumbers(tdrRuleArray);
      for (let item in tdrRuleArray) {
        this.tdrPcFourthModel1.push(item);
      }
    }
    return this.tdrPcFourthModel1;
  }
  public tdrIosZeroModel1: any = [];
  public gettdrIosZeroModel1(scene: any) {
    if (scene != 9999) {
      if (this.rule_settings.tdr_risk_rule[scene].iOS == undefined) {
        this.rule_settings.tdr_risk_rule[scene].iOS = {};
        this.rule_settings.tdr_risk_rule[scene].iOS.level_0 = JSON.parse(
          JSON.stringify(this.rule_settings.tdr_risk_rule.iOS.level_0)
        );
      }

      let tdrRuleArray = [];
      tdrRuleArray = this.rule_settings.tdr_risk_rule[scene]?.iOS?.level_0;

      this.convertNumbers(tdrRuleArray);
      this.tdrIosZeroModel1 = [];
      for (let item in tdrRuleArray) {
        this.tdrIosZeroModel1.push(item);
      }
    }
    return this.tdrIosZeroModel1;
  }
  public tdrIosFirstModel1: any = [];
  public gettdrIosFirstModel1(scene: any) {
    if (scene != 9999) {
      if (this.rule_settings.tdr_risk_rule[scene]?.iOS.level_1 == undefined) {
        this.rule_settings.tdr_risk_rule[scene].iOS.level_1 = JSON.parse(
          JSON.stringify(this.rule_settings.tdr_risk_rule.iOS.level_1)
        );
      }
      let tdrRuleArray = [];
      tdrRuleArray = this.rule_settings.tdr_risk_rule[scene]?.iOS?.level_1;
      this.tdrIosFirstModel1 = [];
      this.convertNumbers(tdrRuleArray);
      for (let item in tdrRuleArray) {
        this.tdrIosFirstModel1.push(item);
      }
    }
    return this.tdrIosFirstModel1;
  }
  public tdrIosSecondModel1: any = [];
  public gettdrIosSecondModel1(scene: any) {
    if (scene != 9999) {
      if (this.rule_settings.tdr_risk_rule[scene]?.iOS.level_2 == undefined) {
        this.rule_settings.tdr_risk_rule[scene].iOS.level_2 = JSON.parse(
          JSON.stringify(this.rule_settings.tdr_risk_rule.iOS.level_2)
        );
      }
      let tdrRuleArray = [];
      tdrRuleArray = this.rule_settings.tdr_risk_rule[scene]?.iOS?.level_2;
      this.tdrIosSecondModel1 = [];
      this.convertNumbers(tdrRuleArray);
      for (let item in tdrRuleArray) {
        this.tdrIosSecondModel1.push(item);
      }
    }
    return this.tdrIosSecondModel1;
  }
  public tdrIosThirdModel1: any = [];
  public gettdrIosThirdModel1(scene: any) {
    if (scene != 9999) {
      if (this.rule_settings.tdr_risk_rule[scene]?.iOS.level_3 == undefined) {
        this.rule_settings.tdr_risk_rule[scene].iOS.level_3 = JSON.parse(
          JSON.stringify(this.rule_settings.tdr_risk_rule.iOS.level_3)
        );
      }
      let tdrRuleArray = [];
      tdrRuleArray = this.rule_settings.tdr_risk_rule[scene]?.iOS?.level_3;
      this.tdrIosThirdModel1 = [];
      this.convertNumbers(tdrRuleArray);
      for (let item in tdrRuleArray) {
        this.tdrIosThirdModel1.push(item);
      }
    }
    return this.tdrIosThirdModel1;
  }
  public tdrIosfourthModel1: any = [];
  public gettdrIosfourthModel1(scene: any) {
    if (scene != 9999) {
      if (this.rule_settings.tdr_risk_rule[scene]?.iOS.level_4 == undefined) {
        this.rule_settings.tdr_risk_rule[scene].iOS.level_4 = JSON.parse(
          JSON.stringify(this.rule_settings.tdr_risk_rule.iOS.level_4)
        );
      }
      let tdrRuleArray = [];
      tdrRuleArray = this.rule_settings.tdr_risk_rule[scene]?.iOS?.level_4;
      this.tdrIosfourthModel1 = [];
      this.convertNumbers(tdrRuleArray);
      for (let item in tdrRuleArray) {
        this.tdrIosfourthModel1.push(item);
      }
    }
    return this.tdrIosfourthModel1;
  }
  public show = true;
  public id_list = [];
  public async ruleChange(id) {
    this.show = false;
    console.log(this.rule_settings.tdr_risk_rule);
    await this.gettdrZeroModel1(id);
    await this.gettdrFirstModel1(id);
    await this.gettdrSecondModel1(id);
    await this.gettdrThirdModel1(id);
    await this.gettdrFourthModel1(id);
    await this.gettdrIosZeroModel1(id);
    await this.gettdrIosFirstModel1(id);
    await this.gettdrIosSecondModel1(id);
    await this.gettdrIosThirdModel1(id);

    await this.gettdrIosfourthModel1(id);

    await this.gettdrPcModel1(id);
    await this.gettdrPcFirstModel1(id);
    await this.gettdrPcSecondModel1(id);
    await this.gettdrPcThirdModel1(id);
    await this.gettdrPcFourthModel1(id);

    this.show = true;

    if (id != 9999) {
      // 记录ID 后期方面删除

      this.id_list.push(id);
    }
  }
  // tdr安卓第一机型
  public tdrFirstModel: any = [];
  public get gettdrFirstModel() {
    if (this.rule_settings.tdr_risk_rule.Android == undefined) {
      this.rule_settings.tdr_risk_rule.Android = {};
    }
    const tdrRuleArray: any = this.rule_settings.tdr_risk_rule?.Android.level_1;
    for (let item in tdrRuleArray) {
      this.tdrFirstModel.push(item);
    }
    return this.tdrFirstModel;
  }
  public tdrPcFirstModel: any = [];
  public get gettdrPcFirstModel() {
    if (this.rule_settings.tdr_risk_rule.PC.level_1 == undefined) {
      this.rule_settings.tdr_risk_rule.PC.level_1 = {
        avg_fps: "",
        max_pss: "",
      };
    }
    const tdrRuleArray: any = this.rule_settings.tdr_risk_rule?.PC.level_1;
    for (let item in tdrRuleArray) {
      this.tdrPcFirstModel.push(item);
    }
    return this.tdrPcFirstModel;
  }
  // tdr安卓 第二机型
  public tdrSecondModel: any = [];
  public get gettdrSecondModel() {
    if (this.rule_settings.tdr_risk_rule.Android == undefined) {
      this.rule_settings.tdr_risk_rule.Android = {};
    }
    const tdrRuleArray: any = this.rule_settings.tdr_risk_rule.Android.level_2;
    for (let item in tdrRuleArray) {
      this.tdrSecondModel.push(item);
    }
    return this.tdrSecondModel;
  }
  public tdrPcSecondModel: any = [];
  public get gettdrPcSecondModel() {
    if (this.rule_settings.tdr_risk_rule.PC.level_2 == undefined) {
      this.rule_settings.tdr_risk_rule.PC.level_2 = {
        avg_fps: "",
        max_pss: "",
      };
    }
    const tdrRuleArray: any = this.rule_settings.tdr_risk_rule.PC.level_2;
    for (let item in tdrRuleArray) {
      this.tdrPcSecondModel.push(item);
    }
    return this.tdrPcSecondModel;
  }
  // tdr安卓 第三机型
  public tdrThirdModel: any = [];
  public get gettdrThirdModel() {
    if (this.rule_settings.tdr_risk_rule.Android == undefined) {
      this.rule_settings.tdr_risk_rule.Android = {};
    }
    const tdrRuleArray: any = this.rule_settings.tdr_risk_rule.Android.level_3;
    for (let item in tdrRuleArray) {
      this.tdrThirdModel.push(item);
    }
    return this.tdrThirdModel;
  }
  public tdrPcThirdModel: any = [];
  public get gettdrPcThirdModel() {
    if (this.rule_settings.tdr_risk_rule.PC.level_3 == undefined) {
      this.rule_settings.tdr_risk_rule.PC.level_3 = {
        avg_fps: "",
        max_pss: "",
      };
    }
    const tdrRuleArray: any = this.rule_settings.tdr_risk_rule.PC.level_3;
    for (let item in tdrRuleArray) {
      this.tdrPcThirdModel.push(item);
    }
    return this.tdrPcThirdModel;
  }
  // tdr安卓 第四机型
  public tdrFourthModel: any = [];
  public get gettdrFourthModel() {
    if (this.rule_settings.tdr_risk_rule.Android.level_4 == undefined) {
      this.rule_settings.tdr_risk_rule.Android.level_4 = {
        avg_fps: "",
        max_pss: "",
      };
      const tdrRuleArray: any = this.rule_settings.tdr_risk_rule.Android
        .level_4;
      for (let item in tdrRuleArray) {
        this.tdrFourthModel.push(item);
      }
    } else {
      const tdrRuleArray: any = this.rule_settings.tdr_risk_rule.Android
        .level_4;
      for (let item in tdrRuleArray) {
        this.tdrFourthModel.push(item);
      }
    }

    return this.tdrFourthModel;
  }
  public tdrPcFourthModel: any = [];
  public get gettdrPcFourthModel() {
    console.log(this.rule_settings.tdr_risk_rule.PC);
    if (this.rule_settings.tdr_risk_rule.PC.level_4 == undefined) {
      this.rule_settings.tdr_risk_rule.PC.level_4 = {
        avg_fps: "",
        max_pss: "",
      };
      const tdrRuleArray: any = this.rule_settings.tdr_risk_rule.PC.level_4;
      for (let item in tdrRuleArray) {
        this.tdrPcFourthModel.push(item);
      }
    } else {
      const tdrRuleArray: any = this.rule_settings.tdr_risk_rule.PC.level_4;
      for (let item in tdrRuleArray) {
        this.tdrPcFourthModel.push(item);
      }
    }

    return this.tdrPcFourthModel;
  }
  // tdIOS  超高端
  public tdrIosZeroModel: any = [];
  public get gettdrIosZeroModel() {
    if (this.rule_settings.tdr_risk_rule.iOS.level_0 == undefined) {
      this.rule_settings.tdr_risk_rule.iOS.level_0 = {
        avg_fps: "",
        max_pss: "",
      };
      const tdrRuleArray: any = this.rule_settings.tdr_risk_rule.iOS.level_0;
      for (let item in tdrRuleArray) {
        this.tdrIosZeroModel.push(item);
      }
    } else {
      const tdrRuleArray: any = this.rule_settings.tdr_risk_rule.iOS.level_0;
      for (let item in tdrRuleArray) {
        this.tdrIosZeroModel.push(item);
      }
    }

    return this.tdrIosZeroModel;
  }
  // tdIOS  超低端
  public tdrIosfourthModel: any = [];
  public get gettdrIosfourthModel() {
    if (this.rule_settings.tdr_risk_rule.iOS.level_4 == undefined) {
      this.rule_settings.tdr_risk_rule.iOS.level_4 = {
        avg_fps: "",
        max_pss: "",
      };
      const tdrRuleArray: any = this.rule_settings.tdr_risk_rule.iOS.level_4;
      for (let item in tdrRuleArray) {
        this.tdrIosfourthModel.push(item);
      }
    } else {
      const tdrRuleArray: any = this.rule_settings.tdr_risk_rule.iOS.level_4;
      for (let item in tdrRuleArray) {
        this.tdrIosfourthModel.push(item);
      }
    }

    return this.tdrIosfourthModel;
  }
  // tdrIOS 第1机型
  public tdrIosFirstModel: any = [];
  public get gettdrIosFirstModel() {
    if (this.rule_settings.tdr_risk_rule.iOS == undefined) {
      this.rule_settings.tdr_risk_rule.iOS = {};
    }
    const tdrRuleArray: any = this.rule_settings.tdr_risk_rule.iOS.level_1;
    for (let item in tdrRuleArray) {
      this.tdrIosFirstModel.push(item);
    }
    return this.tdrIosFirstModel;
  }
  // tdrIOS 第2机型
  public tdrIosSecondModel: any = [];
  public get gettdrIosSecondModel() {
    if (this.rule_settings.tdr_risk_rule.iOS == undefined) {
      this.rule_settings.tdr_risk_rule.iOS = {};
    }
    const tdrRuleArray: any = this.rule_settings.tdr_risk_rule.iOS.level_2;
    for (let item in tdrRuleArray) {
      this.tdrIosSecondModel.push(item);
    }

    return this.tdrIosSecondModel;
  }
  // tdrIOS 第3机型
  public tdrIosThirdModel: any = [];
  public get gettdrIosThirdModel() {
    if (this.rule_settings.tdr_risk_rule.iOS == undefined) {
      this.rule_settings.tdr_risk_rule.iOS = {};
    }
    const tdrRuleArray: any = this.rule_settings.tdr_risk_rule.iOS.level_3;
    for (let item in tdrRuleArray) {
      this.tdrIosThirdModel.push(item);
    }
    return this.tdrIosThirdModel;
  }
  // 测试结论阈值
  public get getaov3() {
    const aovArray: any = this.report_settings.aov_3;
    for (let item in aovArray) {
      this.aov3.push(item);
    }

    return this.aov3;
  }
  public get getaov4() {
    const aovArray: any = this.report_settings.aov_3;
    for (let item in aovArray) {
      this.aov4.push(item);
    }

    return this.aov4;
  }
  public get getaov() {
    const aovArray: any = this.report_settings.aov;
    for (let item in aovArray) {
      this.aov.push(item);
    }

    return this.aov;
  }
  public get getaov1() {
    const aovArray: any = this.report_settings.aov;
    for (let item in aovArray) {
      this.aov1.push(item);
    }

    return this.aov1;
  }

  //指标变化标记阈值
  public get getThreshold() {
    const ThresholdArray: any = this.rule_settings.change_rule.threshold;
    for (let item in ThresholdArray) {
      this.Threshold.push(item);
    }
    return this.Threshold;
  }
  // 一档机型
  public get getFirstModel() {
    const firtstArray: any = this.report_settings.top.risk_rule.Android.level_1;

    for (let item in firtstArray) {
      this.firstModel.push(item);
    }
    return this.firstModel;
  }
  // 第二机型
  public get getsecondModel() {
    const secondArray: any = this.report_settings.top.risk_rule.Android.level_2;

    for (let item in secondArray) {
      this.secondModel.push(item);
    }
    return this.secondModel;
  }
  // 第三机型
  public get getthirdModel() {
    const thirdArray: any = this.report_settings.top.risk_rule.Android.level_3;

    for (let item in thirdArray) {
      this.thirdModel.push(item);
    }
    return this.thirdModel;
  }
  // tdr一档机型
  // public get getTdrFirstModel(){
  //   const firstArray:any=this.
  // }
  // 还原
  public reduction() {
    this.get_project();
    this.handleClearAll2("riskRule");
    this.handleClearAll2("Threshold");
    // this.dataConversion(this.rule_settings.risk_rule);
    this.dataConversion(this.rule_settings.change_rule.threshold);
    this.getriskRule;
    this.getThreshold;
    // this.getaov;
    // this.getaov1;
  }

  public handleClearAll(type: string) {
    if (type !== "basic" && type !== "advance" && type !== "customize") {
      (this.report_settings.content as any)[type] = [];
    } else {
      (this.report_settings.content.index_type as any)[type] = [];
    }
  }
  public handleClearAll7(type: string, scene) {
    if (type === "tdrZeroModel1") {
      this.tdrZeroModel1 = [];
      this.rule_settings.tdr_risk_rule[scene].Android.level_0 = {};
      //  this.delete_null( this.rule_settings.tdr_risk_rule[scene].Android.level_0)
    } else if (type === "tdrFirstModel1") {
      this.tdrZeroModel1 = [];
      this.rule_settings.tdr_risk_rule[scene].Android.level_1 = {};
    } else if (type === "tdrSecondModel1") {
      this.tdrSecondModel1 = [];
      this.rule_settings.tdr_risk_rule[scene].Android.level_2 = {};
    } else if (type === "tdrPcZeroModel1") {
      this.tdrPcZeroModel1 = [];
      this.rule_settings.tdr_risk_rule.PC.level_0 = {};
    } else if (type === "tdrPcFirstModel1") {
      this.tdrPcFirstModel1 = [];
      this.rule_settings.tdr_risk_rule.PC.level_1 = {};
    } else if (type === "tdrPcSecondModel1") {
      this.tdrPcSecondModel1 = [];
      this.rule_settings.tdr_risk_rule.PC.level_2 = {};
    } else if (type === "tdrPcThirdModel1") {
      this.tdrPcThirdModel1 = [];
      this.rule_settings.tdr_risk_rule.PC.level_3 = {};
    } else if (type === "tdrPcFourthModel1") {
      this.tdrPcFourthModel1 = [];
      this.rule_settings.tdr_risk_rule.PC.level_4 = {};
    } else if (type === "tdrThirdModel1") {
      this.tdrThirdModel1 = [];
      this.rule_settings.tdr_risk_rule[scene].Android.level_3 = {};
    } else if (type === "tdrFourthModel1") {
      this.tdrFourthModel1 = [];
      this.rule_settings.tdr_risk_rule[scene].Android.level_4 = {};
    } else if (type === "tdrIosZeroModel1") {
      this.tdrIosZeroModel1 = [];
      this.rule_settings.tdr_risk_rule[scene].Android.level_0 = {};
    } else if (type === "tdrIosFirstModel1") {
      this.tdrIosFirstModel1 = [];
      this.rule_settings.tdr_risk_rule[scene].Android.level_1 = {};
    } else if (type === "tdrIosSecondModel1") {
      this.tdrIosSecondModel1 = [];
      this.rule_settings.tdr_risk_rule[scene].Android.level_2 = {};
    } else if (type === "tdrIosThirdModel1") {
      this.tdrIosThirdModel1 = [];
      this.rule_settings.tdr_risk_rule[scene].Android.level_3 = {};
    } else if (type === "tdrIosfourthModel1") {
      this.tdrIosfourthModel1 = [];
      this.rule_settings.tdr_risk_rule[scene].Android.level_4 = {};
    }
  }
  // public handleSelectAll7(type,scene){

  // }
  public handleClearAll2(type: string) {
    if (type === "riskRule") {
      this.riskRule = [];
      this.rule_settings.risk_rule = {};
    }
    // if (type === "absRiskRule") {
    //   this.absRiskRule = [];
    //   this.rule_settings.abs_risk_rule = {};
    // }
    else if (type === "tdrFirstModel") {
      this.tdrFirstModel = [];
      this.rule_settings.tdr_risk_rule.Android.level_1 = {};
    } else if (type === "tdrSecondModel") {
      this.tdrSecondModel = [];
      this.rule_settings.tdr_risk_rule.Android.level_2 = {};
    } else if (type === "tdrThirdModel") {
      this.tdrThirdModel = [];
      this.rule_settings.tdr_risk_rule.Android.level_3 = {};
    } else if (type === "tdrIosFirstModel") {
      this.tdrIosFirstModel = [];
      this.rule_settings.tdr_risk_rule.iOS.level_1 = {};
    } else if (type === "tdrIosSecondModel") {
      this.tdrIosSecondModel = [];
      this.rule_settings.tdr_risk_rule.iOS.level_2 = {};
    } else if (type === "tdrIosThirdModel") {
      this.tdrIosThirdModel = [];
      this.rule_settings.tdr_risk_rule.iOS.level_3 = {};
    } else if (type === "tdrZeroModel") {
      this.tdrZeroModel = [];
      this.rule_settings.tdr_risk_rule.Android.level_0 = {};
    } else if (type === "tdrFourthModel") {
      this.tdrFourthModel = [];
      this.rule_settings.tdr_risk_rule.Android.level_4 = {};
    } else if (type === "tdrIosZeroModel") {
      this.tdrIosZeroModel = [];
      this.rule_settings.tdr_risk_rule.iOS.level_0 = {};
    } else if (type === "tdrIosfourthModel") {
      this.tdrIosfourthModel = [];
      this.rule_settings.tdr_risk_rule.iOS.level_4 = {};
    } else if (type === "tdrPcZeroModel") {
      this.tdrPcZeroModel = [];
      this.rule_settings.tdr_risk_rule.PC.level_0 = {};
    } else if (type === "tdrPcFirstModel") {
      this.tdrPcFirstModel = [];
      this.rule_settings.tdr_risk_rule.PC.level_1 = {};
    } else if (type === "tdrPcSecondModel") {
      this.tdrPcSecondModel = [];
      this.rule_settings.tdr_risk_rule.PC.level_2 = {};
    } else if (type === "tdrPcThirdModel") {
      this.tdrPcThirdModel = [];
      this.rule_settings.tdr_risk_rule.PC.level_3 = {};
    } else if (type === "tdrPcFourthModel") {
      this.tdrPcFourthModel = [];
      this.rule_settings.tdr_risk_rule.PC.level_4 = {};
    } else {
      this.Threshold = [];
      this.rule_settings.change_rule.threshol = {};
    }
  }

  public handleClearAll3() {
    (this.report_settings.common_aov as any).increase_good = [];
  }
  public handleClearAll4(type: string) {
    if (type === "aov") {
      this.aov = [];
      this.report_settings.aov = {};
    } else if (type === "aov_3") {
      this.aov3 = [];
      this.report_settings.aov_3 = {};
    }
  }
  public handleSelectAll4(type: string) {
    if (type == "aov") {
      this.aov = this.getaov1;
    } else if (type === "aov_3") {
      this.aov3 = this.getaov4;
    }
  }
  public handleClearAll5(type: any) {
    if (type === "level_1") {
      this.firstModel = [];
      this.report_settings.top.risk_rule.Android[type] = {};
    } else if (type === "level_2") {
      this.secondModel = [];
      this.report_settings.top.risk_rule.Android[type] = {};
    } else if (type === "level_3") {
      this.thirdModel = [];
      this.report_settings.top.risk_rule.Android[type] = {};
    }
  }
  public handleSelectAll3(type: string) {
    (this.report_settings.common_aov as any).increase_good = this.testData;
  }
  public handleSelectAll5(type: any, all_list: any) {
    if (type === "leavel_1") {
      this.firstModel = all_list;
    } else if (type === "leavel_2") {
      this.secondModel = all_list;
    } else if (type === "leavel_3") {
      this.thirdModel = all_list;
    }
  }

  public handleSelectAll(type: string, all_list: any[]) {
    if (type !== "basic" && type !== "advance" && type !== "customize") {
      if (
        type === "core_scene" ||
        type === "trend_scene" ||
        type === "exclude_scene" ||
        type === "exclude_device"
      ) {
        const item = all_list.map((item) => item.id);
        (this.report_settings.content as any)[type] = item;
      } else {
        (this.report_settings.content as any)[type] = all_list;
      }
    } else {
      let difference = [];
      if (type === "basic") {
        let advance_customize: string[] = [];
        advance_customize.push(
          ...this.report_settings.content.index_type.customize
        );
        advance_customize.push(
          ...this.report_settings.content.index_type.advance
        );
        // （a-b 差集：属于a但不属于b的集合）a-b=[1,3],b-a=[4,5] eg: a = [1, 2, 3]，b = [2, 4, 5]
        difference = all_list.filter((v) => !advance_customize.includes(v));
      } else if (type === "advance") {
        let basic_customize: string[] = [];
        basic_customize.push(
          ...this.report_settings.content.index_type.customize
        );
        basic_customize.push(...this.report_settings.content.index_type.basic);
        difference = all_list.filter((v) => !basic_customize.includes(v));
      } else {
        let basic_advance: string[] = [];
        basic_advance.push(...this.report_settings.content.index_type.advance);
        basic_advance.push(...this.report_settings.content.index_type.basic);
        difference = all_list.filter((v) => !basic_advance.includes(v));
      }

      (this.report_settings.content.index_type as any)[type] = difference;
    }
  }

  public handleSelectAll2(type: string) {
    if (type === "riskRule") {
      this.riskRule = this.report_settings.content.core_index;
    }
    // if (type === "absRiskRule") {
    //   this.absRiskRule = this.report_settings.content.core_index;
    // }
    else if (type === "tdrFirstModel") {
      this.tdrFirstModel = this.report_settings.content.core_index;
    } else if (type === "tdrPcZeroModel") {
      this.tdrPcZeroModel = this.report_settings.content.core_index;
    } else if (type === "tdrPcFirstModel") {
      this.tdrPcFirstModel = this.report_settings.content.core_index;
    } else if (type === "tdrPcSecondModel") {
      this.tdrPcSecondModel = this.report_settings.content.core_index;
    } else if (type === "tdrPcThirdModel") {
      this.tdrPcThirdModel = this.report_settings.content.core_index;
    } else if (type === "tdrPcFourthModel") {
      this.tdrPcFourthModel = this.report_settings.content.core_index;
    } else if (type === "tdrPcZeroModel1") {
      this.tdrPcZeroModel1 = this.report_settings.content.core_index;
    } else if (type === "tdrPcFirstModel1") {
      this.tdrPcFirstModel1 = this.report_settings.content.core_index;
    } else if (type === "tdrPcSecondModel1") {
      this.tdrPcSecondModel1 = this.report_settings.content.core_index;
    } else if (type === "tdrPcThirdModel1") {
      this.tdrPcThirdModel1 = this.report_settings.content.core_index;
    } else if (type === "tdrPcFourthModel1") {
      this.tdrPcFourthModel1 = this.report_settings.content.core_index;
    } else if (type === "tdrSecondModel") {
      this.tdrSecondModel = this.report_settings.content.core_index;
    } else if (type === "tdrThirdModel") {
      this.tdrThirdModel = this.report_settings.content.core_index;
    } else if (type === "tdrIosFirstModel") {
      this.tdrIosFirstModel = this.report_settings.content.core_index;
    } else if (type === "tdrIosSecondModel") {
      this.tdrIosSecondModel = this.report_settings.content.core_index;
    } else if (type === "tdrIosThirdModel") {
      this.tdrIosThirdModel = this.report_settings.content.core_index;
    } else if (type === "tdrIosfourthModel") {
      this.tdrIosfourthModel = this.report_settings.content.core_index;
    } else if (type === "tdrIosZeroModel") {
      this.tdrIosZeroModel = this.report_settings.content.core_index;
    } else if (type === "tdrFourthModeltdrFourthModel") {
      this.tdrFourthModel = this.report_settings.content.core_index;
    } else if (type === "tdrZeroModel") {
      this.tdrZeroModel = this.report_settings.content.core_index;
    } else if (type === "tdrZeroModel1") {
      this.tdrZeroModel1 = this.report_settings.content.core_index;
    } else if (type === "tdrSecondModel1") {
      this.tdrSecondModel1 = this.report_settings.content.core_index;
    } else if (type === "tdrThirdModel1") {
      this.tdrThirdModel1 = this.report_settings.content.core_index;
    } else if (type === "tdrFourthModel1") {
      this.tdrFourthModel1 = this.report_settings.content.core_index;
    } else if (type === "tdrIosZeroModel1") {
      this.tdrIosZeroModel1 = this.report_settings.content.core_index;
    } else if (type === "tdrIosFirstModel1") {
      this.tdrIosFirstModel1 = this.report_settings.content.core_index;
    } else if (type === "tdrIosSecondModel1") {
      this.tdrIosSecondModel1 = this.report_settings.content.core_index;
    } else if (type === "tdrIosThirdModel1") {
      this.tdrIosThirdModel1 = this.report_settings.content.core_index;
    } else if (type === "tdrIosfourthModel1") {
      this.tdrIosfourthModel1 = this.report_settings.content.core_index;
    } else {
      this.Threshold = this.get_all_indexes;
    }
  }

  // 详细指标选择框
  public get_detailed_indexes(type: string, index: string) {
    const basic: any[] = this.report_settings.content.index_type.basic;
    const advance: any[] = this.report_settings.content.index_type.advance;
    const customize: any[] = this.report_settings.content.index_type.customize;
    const all_inedx = readAllIndexes(store);
    if (type === "basic") {
      if (advance.includes(index) || customize.includes(index)) {
        return true;
      }
    }
    if (type === "advance") {
      if (basic.includes(index) || customize.includes(index)) {
        return true;
      }
    }
    if (type === "customize") {
      if (advance.includes(index) || basic.includes(index)) {
        return true;
      }
    }
    return false;
  }

  public handleClose(tag: any, type: string) {
    if (type !== "basic" && type !== "advance" && type !== "customize") {
      (this.report_settings.content as any)?.[type].splice(
        (this.report_settings.content as any)?.[type].indexOf(tag),
        1
      );
    } else {
      (this.report_settings.content.index_type as any)?.[type].splice(
        (this.report_settings.content.index_type as any)?.[type].indexOf(tag),
        1
      );
    }
  }
  public handleClose3(i: any) {
    this.report_settings.common_aov?.increase_good?.splice(i, 1);
  }
  public handleClose7(tag: any, type: string, scene) {
    if (type === "tdrZeroModel1") {
      this.rule_settings.tdr_risk_rule[scene].Android.level_0[tag] = "";
      this.tdrZeroModel1.splice(this.tdrZeroModel1.indexOf(tag), 1);
      this.delete_null(this.rule_settings.tdr_risk_rule[scene].Android.level_0);
    } else if (type === "tdrPcZeroModel1") {
      this.rule_settings.tdr_risk_rule.PC.level_0[tag] = "";
      this.tdrPcZeroModel1.splice(this.tdrPcZeroModel1.indexOf(tag), 1);
      this.delete_null(this.rule_settings.tdr_risk_rule[scene].PC.level_0);
    } else if (type === "tdrPcFirstModel1") {
      this.rule_settings.tdr_risk_rule.PC.level_1[tag] = "";
      this.tdrPcFirstModel1.splice(this.tdrPcFirstModel1.indexOf(tag), 1);
      this.delete_null(this.rule_settings.tdr_risk_rule[scene].PC.level_1);
    } else if (type === "tdrPcSecondModel1") {
      this.rule_settings.tdr_risk_rule.PC.level_2[tag] = "";
      this.tdrPcSecondModel1.splice(this.tdrPcSecondModel1.indexOf(tag), 1);
      this.delete_null(this.rule_settings.tdr_risk_rule[scene].PC.level_2);
    } else if (type === "tdrPcThirdModel1") {
      this.rule_settings.tdr_risk_rule.PC.level_3[tag] = "";
      this.tdrPcThirdModel1.splice(this.tdrPcThirdModel1.indexOf(tag), 1);
      this.delete_null(this.rule_settings.tdr_risk_rule[scene].PC.level_3);
    } else if (type === "tdrPcFourthModel1") {
      this.rule_settings.tdr_risk_rule.PC.level_4[tag] = "";
      this.tdrPcFourthModel1.splice(this.tdrPcFourthModel1.indexOf(tag), 1);
      this.delete_null(this.rule_settings.tdr_risk_rule[scene].PC.level_4);
    } else if (type === "tdrFirstModel1") {
      this.rule_settings.tdr_risk_rule[scene].Android.level_1[tag] = "";
      this.tdrFirstModel1.splice(this.tdrFirstModel1.indexOf(tag), 1);
      this.delete_null(this.rule_settings.tdr_risk_rule[scene].Android.level_1);
    } else if (type === "tdrSecondModel1") {
      this.rule_settings.tdr_risk_rule[scene].Android.level_2[tag] = "";
      this.tdrSecondModel1.splice(this.tdrSecondModel1.indexOf(tag), 1);
      this.delete_null(this.rule_settings.tdr_risk_rule[scene].Android.level_2);
    } else if (type === "tdrThirdModel1") {
      this.rule_settings.tdr_risk_rule[scene].Android.level_3[tag] = "";
      this.tdrThirdModel1.splice(this.tdrThirdModel1.indexOf(tag), 1);
      this.delete_null(this.rule_settings.tdr_risk_rule[scene].Android.level_3);
    } else if (type === "tdrFourthModel1") {
      this.rule_settings.tdr_risk_rule[scene].Android.level_4[tag] = "";
      this.tdrFourthModel1.splice(this.tdrFourthModel1.indexOf(tag), 1);
      this.delete_null(this.rule_settings.tdr_risk_rule[scene].Android.level_4);
    } else if (type === "tdrIosZeroModel1") {
      this.rule_settings.tdr_risk_rule[scene].iOS.level_0[tag] = "";
      this.tdrIosZeroModel1.splice(this.tdrIosZeroModel1.indexOf(tag), 1);
      this.delete_null(this.rule_settings.tdr_risk_rule[scene].iOS.level_0);
    } else if (type === "tdrIosFirstModel1") {
      this.rule_settings.tdr_risk_rule[scene].iOS.level_1[tag] = "";
      this.tdrIosFirstModel1.splice(this.tdrIosFirstModel1.indexOf(tag), 1);
      this.delete_null(this.rule_settings.tdr_risk_rule[scene].iOS.level_1);
    } else if (type === "tdrIosSecondModel1") {
      this.rule_settings.tdr_risk_rule[scene].iOS.level_2[tag] = "";
      this.tdrIosSecondModel1.splice(this.tdrIosSecondModel1.indexOf(tag), 1);
      this.delete_null(this.rule_settings.tdr_risk_rule[scene].iOS.level_2);
    } else if (type === "tdrIosThirdModel1") {
      this.rule_settings.tdr_risk_rule[scene].iOS.level_3[tag] = "";
      this.tdrIosThirdModel1.splice(this.tdrIosThirdModel1.indexOf(tag), 1);
      this.delete_null(this.rule_settings.tdr_risk_rule[scene].iOS.level_3);
    } else if (type === "tdrIosfourthModel1") {
      this.rule_settings.tdr_risk_rule[scene].iOS.level_4[tag] = "";
      this.tdrIosfourthModel1.splice(this.tdrIosfourthModel1.indexOf(tag), 1);
      this.delete_null(this.rule_settings.tdr_risk_rule[scene].iOS.level_4);
    }
  }
  public handleClose2(tag: any, type: string) {
    if (type === "riskRule") {
      this.riskRule.splice(this.riskRule.indexOf(tag), 1);

      this.rule_settings.risk_rule[tag] = "";
    }
    // if (type === "absRiskRule") {
    //   this.rule_settings.abs_risk_rule[tag] = "";
    //   this.absRiskRule.splice(this.absRiskRule.indexOf(tag), 1);
    // }
    else if (type === "tdrPcZeroModel") {
      this.rule_settings.tdr_risk_rule.PC.level_0[tag] = "";
      this.tdrPcZeroModel.splice(this.tdrPcZeroModel.indexOf(tag), 1);
    } else if (type === "tdrPcFirstModel") {
      this.rule_settings.tdr_risk_rule.PC.level_1[tag] = "";
      this.tdrPcFirstModel.splice(this.tdrPcFirstModel.indexOf(tag), 1);
    } else if (type === "tdrPcSecondModel") {
      this.rule_settings.tdr_risk_rule.PC.level_2[tag] = "";
      this.tdrPcSecondModel.splice(this.tdrPcSecondModel.indexOf(tag), 1);
    } else if (type === "tdrPcThirdModel") {
      this.rule_settings.tdr_risk_rule.PC.level_3[tag] = "";
      this.tdrPcThirdModel.splice(this.tdrPcThirdModel.indexOf(tag), 1);
    } else if (type === "tdrPcFourthModel") {
      this.rule_settings.tdr_risk_rule.PC.level_4[tag] = "";
      this.tdrPcFourthModel.splice(this.tdrPcFourthModel.indexOf(tag), 1);
    } else if (type === "tdrFirstModel") {
      this.rule_settings.tdr_risk_rule.Android.level_1[tag] = "";
      this.tdrFirstModel.splice(this.tdrFirstModel.indexOf(tag), 1);
    } else if (type === "tdrSecondModel") {
      this.rule_settings.tdr_risk_rule.Android.level_2[tag] = "";
      this.tdrSecondModel.splice(this.tdrSecondModel.indexOf(tag), 1);
    } else if (type === "tdrThirdModel") {
      this.rule_settings.tdr_risk_rule.Android.level_3[tag] = "";
      this.tdrThirdModel.splice(this.tdrThirdModel.indexOf(tag), 1);
    } else if (type === "tdrIosFirstModel") {
      this.rule_settings.tdr_risk_rule.iOS.level_1[tag] = "";
      this.tdrIosFirstModel.splice(this.tdrIosFirstModel.indexOf(tag), 1);
    } else if (type === "tdrIosSecondModel") {
      this.rule_settings.tdr_risk_rule.iOS.level_2[tag] = "";
      this.tdrIosSecondModel.splice(this.tdrIosSecondModel.indexOf(tag), 1);
    } else if (type === "tdrIosThirdModel") {
      this.rule_settings.tdr_risk_rule.iOS.level_3[tag] = "";
      this.tdrIosThirdModel.splice(this.tdrIosThirdModel.indexOf(tag), 1);
    } else if (type === "tdrZeroModel") {
      this.rule_settings.tdr_risk_rule.Android.level_0[tag] = "";
      this.tdrZeroModel.splice(this.tdrZeroModel.indexOf(tag), 1);
    } else if (type === "tdrFourthModel") {
      this.rule_settings.tdr_risk_rule.Android.level_4[tag] = "";
      this.tdrFourthModel.splice(this.tdrFourthModel.indexOf(tag), 1);
    } else if (type === "tdrIosZeroModel") {
      this.rule_settings.tdr_risk_rule.iOS.level_0[tag] = "";
      this.tdrIosZeroModel.splice(this.tdrIosZeroModel.indexOf(tag), 1);
    } else if (type === "tdrIosfourthModel") {
      this.rule_settings.tdr_risk_rule.iOS.level_4[tag] = "";
      this.tdrIosfourthModel.splice(this.tdrIosfourthModel.indexOf(tag), 1);
    } else if (type === "tdrZeroModel") {
      this.rule_settings.tdr_risk_rule.Android.level_0[tag] = "";
      this.tdrZeroModel.splice(this.tdrZeroModel.indexOf(tag), 1);
    } else {
      this.Threshold.splice(this.Threshold.indexOf(tag), 1);
      this.rule_settings.change_rule.threshold[tag] = "";
    }
  }
  public handleClose4(type: string, i: any) {
    if (type === "aov") {
      this.aov.splice(this.aov.indexOf(i), 1);

      this.report_settings.aov[i] = "";
    } else if (type === "aov_3") this.aov3.splice(this.aov3.indexOf(i), 1);
    this.report_settings.aov_3[i] = "";
  }
  public handleClose5(i: any) {
    this.report_settings.top.core_index.splice(i, 1);
  }
  public handleClose6(type: any, i: any) {
    if (type === "level_1") {
      this.firstModel.splice(this.firstModel.indexOf(i), 1);
      this.report_settings.top.risk_rule.Android.level_1[i] = "";
    }
    if (type === "level_2") {
      this.secondModel.splice(this.secondModel.indexOf(i), 1);
      this.report_settings.top.risk_rule.Android.level_2[i] = "";
    }
    if (type === "level_3") {
      this.thirdModel.splice(this.thirdModel.indexOf(i), 1);
      this.report_settings.top.risk_rule.Android.level_3[i] = "";
    }
  }

  // 读取可配置指标
  public get get_all_indexes() {
    return readAllIndexes(store);
  }
  public get_all_indexes_cn(value) {
    const fields = {
      avg_fps: "平均FPS", // 平均FPS
      avg_pss: "均值PSS",
      max_pss: "峰值PSS", // 峰值PSS
      max_mono_used: "maxMonoUsed(M)", // 峰值Used Mono
      max_mono_total: "峰值mono内存(M)", // 峰值Total Mono
      avg_cpu: "平均CPU", // 平均CPU
      fps_lt_10_pcnt: "FPS<=10占⽐(%)", // FPS<=10占有率(%)
      fps_lt_18_pcnt: "FPS>=18占⽐(%)", // FPS>=18占有率(%)
      fps_lt_25_pcnt: "FPS>=25占⽐(%)", // FPS>=25占有率(%)
      fps_lt_40_pcnt: "FPS>=40占⽐(%)", // FPS>=40占有率(%)
      cpu_lt_60_pcnt: "CPU<=60占⽐(%)", // FPS<=60占有率(%)
      cpu_lt_80_pcnt: "CPU<=80占⽐(%)", // FPS<=80占有率(%)
      dps: "dps",
      avg_dc: "平均DC", // 平均DC
      max_dc: "峰值DrawCall数", // 峰值DC
      max_triangle: "峰值三角形数", // 峰值三角形(万)
      duration: "耗时", // 耗时
      avg_flow: "流量(KB/S)", // 流量(KB/S)
      max_swap: "maxSwap",
      max_vss: "maxVss",
      max_swap_add_pss: "maxSwapAddPss",
      process_up_flow: "进程上行流量[KB/s]",
      process_down_flow: "进程下行流量[KB/s]",
      logic_up_flow: "逻辑上行流量[KB/s]",
      logic_down_flow: "逻辑下行流量[KB/s]",
      lag_cnt: "卡顿次数", // 卡顿次数
      single_peak_lag_cnt: "singlePeakLagCnt",
      multiple_peak_lag_cnt: "multiplePeakLagCnt",
      continue_low_lag_cnt: "continueLowLagCnt",
      lag_pcnt: "卡顿率", // 卡顿率
      lag_freq: "卡顿频率",
      id_row_start: "id_row_start",
      id_row_end: "id_row_end",
      id_frame_start: "id_frame_start",
      id_frame_end: "id_frame_end",
      avg_cpu_total: "avgCpuTotal",
      gc_cnt: "GC(次)", // gc_cnt
      gc_freq: "GC频率",
      cpu_temp: "CPU温度",
      gpu_usage: "GPU使用率",
      primitive: "GPU像素吞吐量",
      core_usage: "执行核心使用率",
      variable_unit_usage: "变量单位使用率",
      texture_unit_usage: "纹理单元使用率",
      ls_unit_usage: "LS单元使用率",
      shader_usage: "片元使用率",
      no_shader_usage: "非片元使用率",
      read_beat: "Bandwidth_Read",
      write_beat: "Bandwidth_Write",
      read_stall_pcnt: "外部带宽读延迟率",
      write_stall_pcnt: "外部带宽写延迟率",
      enter_primitive: "输入Primitive数目",
      visible_primitive: "可见Primitive数目",
      visible_triangle_scale: "可见三角形比例",
      cull_triangle_scale: "剔除三角形比例",
      cull_facing_scale: "Facing剔除比例",
      cull_zp_scale: "Z Plane剔除比例",
      cull_sample_scale: "Sample剔除比例",
      cull_ez_scale: "Early ZS 剔除比例",
      cull_fpk_scale: "FPK剔除比例",
      cull_lz_scale: "Late ZS 剔除比例",
      diverged_instructions: "分支指令比例",
      interpolation_active_pcnt_16: "Varying单元16位",
      interpolation_active_pcnt_32: "Varying单元32位",
      overdraw: "OverDraw",
      core_texture_requests: "Core_Texture_Requests",
    };
    if (this.localProject === 7) {
      if (fields[value] != undefined) {
        return fields[value];
      } else {
        return value;
      }
    } else {
      return value;
    }
  }

  public get getDeviceSpecs() {
    // status -> 0: 离线, 1: 占用 , 2: 空闲
    const device_list: any[] = readDeviceSpecs(store);
    for (let device of device_list) {
      Object.assign(device, device.model);
      if (!device.is_online) {
        device.status = "离线";
      } else if (device.is_running) {
        device.status = "占用";
      } else {
        device.status = "空闲";
      }
    }
    return device_list;
  }

  public get_device_model(device_id: number) {
    const device = this.getDeviceSpecs.find(
      (device) => device.id === device_id
    );
    return device.level + 1 + "档机-" + device.model;
  }
  public ProjectScenes = [];
  // 读取屏蔽场景配置指标
  public get getProjectScenes() {
    this.ProjectScenes = [...readProjectScenes(store)];
    this.ProjectScenes.push({ chinese: "全部", id: 9999 });

    return readProjectScenes(store);
  }

  // 屏蔽场景列表
  public get_scene_chinese(scene_id: number) {
    const scene_chinese = this.getProjectScenes.find(
      (scene: any) => scene.id === scene_id
    )?.chinese;
    return scene_chinese;
  }

  public get project_users() {
    return readProjectUsers(store);
  }

  // 读取项目报告配置
  public async get_project() {
    const project = readProjectDetail(store);

    if (
      project.report_settings !== null &&
      project.rule_settings !== null &&
      isJsonString(project.report_settings) &&
      isJsonString(project.rule_settings)
    ) {
      let report_settings_json = JSON.parse(project.report_settings as string);

      let rule_settings_json = JSON.parse(project.rule_settings as string);
      if (report_settings_json !== null && rule_settings_json !== null) {
        if (report_settings_json.notify.email.receiver.length === 0) {
          this.project_users.forEach((item: any) => {
            if (item.is_project_admin === true) {
              report_settings_json.notify.email.receiver.push(item.user);
            }
          });
        }
        if (report_settings_json.notify.wecom.receiver.length === 0) {
          this.project_users.forEach((item: any) => {
            if (item.is_project_admin === true) {
              report_settings_json.notify.wecom.receiver.push(item.user);
            }
          });
        }
        if (report_settings_json.notify.wecom_robot.receiver.length === 0) {
          this.project_users.forEach((item: any) => {
            if (item.is_project_admin === true) {
              report_settings_json.notify.wecom_robot.receiver.push(item.user);
            }
          });
        }
        // 收件人列表转为拼接为字符串
        report_settings_json.notify.email.receiver_str = report_settings_json.notify.email.receiver.join(
          ";"
        );
        report_settings_json.notify.wecom.receiver_str = report_settings_json.notify.wecom.receiver.join(
          ";"
        );
        report_settings_json.notify.wecom_robot.receiver_str = report_settings_json.notify.wecom_robot.receiver.join(
          ";"
        );
        // 给公共属性赋值
        this.report_settings = report_settings_json;
        this.custom = JSON.stringify(this.report_settings.custom as any);
        console.log(this.report_settings);
        if (this.report_settings.custom === undefined) {
          this.report_settings.custom = {};
        }
        if (this.localProject === 7) {
          if ((this.report_settings.custom as any).gpu === undefined) {
            (this.report_settings.custom as any).gpu = {};
            (this.report_settings.custom as any).gpu.time = 1;
          }
        }

        this.custom =
          JSON.stringify(this.report_settings.custom as any) == "{}"
            ? ""
            : JSON.stringify(this.report_settings.custom as any);
        console.log(this.custom);
        console.log(rule_settings_json);
        console.log(this.rule_settings);
        let sceneList = [];
        this.rule_settings = rule_settings_json;
        if (!this.rule_settings.tdr_risk_rule.PC) {
          this.rule_settings.tdr_risk_rule.PC = {};
        }
        for (let i in this.rule_settings.tdr_risk_rule) {
          if (i !== "Android" && i != "iOS" && i !== "PC") {
            sceneList.push(i);
          }
        }
        console.log(sceneList);
        sceneList.forEach((v) => {
          if (!this.rule_settings.tdr_risk_rule[v].PC) {
            this.rule_settings.tdr_risk_rule[v].PC = {};
          }
        });
      }
    }
  }

  public aov_new_value(array: any) {
    for (let obj in array) {
      let value: any = {};
      // aov_value[obj]['treshold_type']='5'
      if (array[obj].search("%") !== -1) {
        value.threshold_type = "percent";
        value.threshold_value = Number(array[obj].replace("%", ""));
        // aov_value[obj]=("threshold_type:"+"'percent'"+",threshold_value:"+aov_value[obj])

        // console.log("threshold_type:"+"'percent'"+",threshold_value:"+aov_value[obj])
      } else {
        value.threshold_type = "number";
        value.threshold_value = Number(array[obj]);
        //  aov_value[obj]=("threshold_type:"+"'number'"+",threshold_value:"+aov_value[obj])
        //  console.log(aov_value[obj].threshold_value)
      }
      array[obj] = value;
    }
  }
  public delete_null(Array: any) {
    for (var key in Array) {
      if (Array[key] === "") {
        delete Array[key];
      }
    }
  }
  public delete_null1(Array: any) {
    for (var key in Array) {
      if (Array[key] === "" || !Array[key]) {
        delete Array[key];
      }
    }
  }
  // 配置AOV测试结论显示
  public get aovShow() {
    return special_projects.aov.includes(this.localProject);
  }
  // 配置 TOP结论显示
  public get topShow() {
    return special_projects.semi.includes(this.localProject);
  }
  // 值的的转换
  public dataConversion(Array: any) {
    for (let i in Array) {
      Array[i] = Array[i] * 100;
    }
  }

  public dataConversion2(Array: any) {
    for (let i in Array) {
      Array[i] = Array[i] / 100;
    }
  }
  public hh(event: any, item: any) {
    console.log(event);
  }
  // public message(Array:any){

  // }
  public custom = "";
  // 提交/并应用
  public async sumbit(boolean: any) {
    this.loading = true;
    let receiver_value: any = this.report_settings.notify.email.receiver_str;
    let receiver_value2: any = this.report_settings.notify.wecom.receiver_str;
    let threshold_value: any = this.rule_settings.change_rule.threshold;
    let riskRule_value: any = this.rule_settings.risk_rule;
    // let absRiskRule_value: any = this.rule_settings.abs_risk_rule;
    let tdrAndroidZero_value: any = this.rule_settings.tdr_risk_rule.Android
      .level_0;
    let tdrAndroidFirst_value: any = this.rule_settings.tdr_risk_rule.Android
      .level_1;
    let tdrAndroidSecond_value: any = this.rule_settings.tdr_risk_rule.Android
      .level_2;
    let tdrAndroidThird_value: any = this.rule_settings.tdr_risk_rule.Android
      .level_3;
    let tdrAndroidFourth_value: any = this.rule_settings.tdr_risk_rule.Android
      .level_4;
    let tdrIosZero_value: any = this.rule_settings.tdr_risk_rule.iOS.level_0;
    let tdrIosFirst_value: any = this.rule_settings.tdr_risk_rule.iOS.level_1;
    let tdrIosSecond_value: any = this.rule_settings.tdr_risk_rule.iOS.level_2;
    let tdrIosThird_value: any = this.rule_settings.tdr_risk_rule.iOS.level_3;

    let tdrIosfourth_value: any = this.rule_settings.tdr_risk_rule.iOS.level_4;
    let tdrPCZero_value: any = this.rule_settings.tdr_risk_rule.PC.level_0;
    let tdrPCFirst_value: any = this.rule_settings.tdr_risk_rule.PC.level_1;
    let tdrPCSecond_value: any = this.rule_settings.tdr_risk_rule.PC.level_2;
    let tdrPCThird_value: any = this.rule_settings.tdr_risk_rule.PC.level_3;

    let tdrPCfourth_value: any = this.rule_settings.tdr_risk_rule.PC.level_4;
    console.log(this.custom);
    if (this.custom == undefined) {
      this.report_settings.custom = {};
    } else {
      this.report_settings.custom =
        this.custom == "" ? {} : JSON.parse(this.custom);
    }
    console.log(this.report_settings);
    console.log(riskRule_value);
    let common_aov_value: any = this.report_settings.common_aov;
    let aov_value: any = this.report_settings.aov;
    let aov3_value: any = this.report_settings.aov_3;
    let core_index_value: any = this.report_settings.top?.core_index;
    let leve1_value = this.report_settings.top?.risk_rule?.Android?.level_1;
    let leve2_value = this.report_settings.top?.risk_rule?.Android?.level_2;
    let leve3_value = this.report_settings.top?.risk_rule?.Android?.level_3;
    this.delete_null1(aov_value);
    this.delete_null1(aov3_value);
    if (this.topShow) {
      this.delete_null1(leve1_value);
      this.delete_null1(leve2_value);
      this.delete_null1(leve3_value);
      this.verification1(this.firstModel, leve1_value);
      this.verification1(this.secondModel, leve2_value);
      this.verification1(this.thirdModel, leve3_value);
    }

    console.log(tdrAndroidSecond_value, tdrAndroidThird_value);
    // let reg = new RegExp("^[0-9]*$");
    //  this.firstModel.forEach((v:any)=>
    //       // console.log(this.report_settings.top.risk_rule.Android.level_1[v].value)
    //       // console.log(this.report_settings.top.risk_rule.Android.level_1[v].risk_value.high)

    //     console.log(reg.test(this.report_settings.top.risk_rule.Android.level_1[v].risk_value.high))

    //  )
    // 验证TOP机型测试设置

    this.verification(this.riskRule, riskRule_value);
    this.verification(this.aov, aov_value);
    this.verification(this.aov3, aov3_value);
    // this.verification(this.absRiskRule, absRiskRule_value);
    //  for(let obj in aov_value){
    //     let value: any = {}
    //     // aov_value[obj]['treshold_type']='5'
    //   if(aov_value[obj].search('%')!==-1){
    //     value.threshold_type = 'percent'
    //     value.threshold_value = Number(aov_value[obj].replace("%", ""))
    //       // aov_value[obj]=("threshold_type:"+"'percent'"+",threshold_value:"+aov_value[obj])

    //       // console.log("threshold_type:"+"'percent'"+",threshold_value:"+aov_value[obj])
    //   }else{
    //     value.threshold_type = 'number'
    //     value.threshold_value = Number(aov_value[obj])
    //   //  aov_value[obj]=("threshold_type:"+"'number'"+",threshold_value:"+aov_value[obj])
    //   //  console.log(aov_value[obj].threshold_value)
    //  }
    //  aov_value[obj] = value

    // }

    // for(let obj in aov_value){
    //   // aov_value[obj]['treshold_type']='5'
    //  if(aov_value[obj].search('%')!==-1){
    //       aov_value[obj]=("threshold_type:"+"'percent'"+",threshold_value:"+aov_value[obj])

    //       console.log("threshold_type:"+"'percent'"+",threshold_value:"+aov_value[obj])
    //  }else{

    //    aov_value[obj]=("threshold_type:"+"'number'"+",threshold_value:"+aov_value[obj])
    //    console.log(aov_value[obj].threshold_value)

    //  }

    // }
    //  for(let obj in aov_value){
    //     let value: any = {}
    //     // aov_value[obj]['treshold_type']='5'
    //   if(aov_value[obj].search('%')!==-1){
    //     value.threshold_type = 'percent'
    //     value.threshold_value = Number(aov_value[obj].replace("%", ""))
    //       // aov_value[obj]=("threshold_type:"+"'percent'"+",threshold_value:"+aov_value[obj])

    //       // console.log("threshold_type:"+"'percent'"+",threshold_value:"+aov_value[obj])
    //   }else{
    //     value.threshold_type = 'number'
    //     value.threshold_value = Number(aov_value[obj])
    //   //  aov_value[obj]=("threshold_type:"+"'number'"+",threshold_value:"+aov_value[obj])
    //   //  console.log(aov_value[obj].threshold_value)
    //  }
    //  aov_value[obj] = value
    // }
    //  for(let obj in leve1_value){
    //    let value:any={};
    //    value.risk_value={}
    //   let newObj=leve1_value[obj].split(";")
    //   console.log(newObj)
    //   value.value=newObj[0]

    //   value.risk_value.middle=newObj[1]
    //   value.risk_value.high=newObj[2]
    //  console.log(value)
    //   leve1_value[obj]=value

    //  }
    if (this.flag.every((v) => v == true)) {
      this.aov_new_value(aov_value);
      this.aov_new_value(aov3_value);
      //     for(let obj in leve1_value){
      //    let value:any={};
      //    value.risk_value={}
      //   let newObj=leve1_value[obj].split(";")
      //   console.log(newObj)
      //   value.value=newObj[0]

      //   value.risk_value.middle=newObj[1]
      //   value.risk_value.high=newObj[2]
      //  console.log(value)
      //   leve1_value[obj]=value

      //  }
      if (this.topShow) {
        this.aow_new_model_value(leve1_value);
        this.aow_new_model_value(leve2_value);
        this.aow_new_model_value(leve3_value);
      }
      ElMessage({
        showClose: true,
        message: "提交成功",
        type: "success",
      });
    } else {
      ElMessage({
        showClose: true,
        message: "请重新修改正确的数字以及百分比",
        type: "error",
      });
      return;
    }

    let submit_receiver_value: any = receiver_value
      .split(";")
      .map((item: any) => {
        return item.substring(0, item.lastIndexOf("("));
      });
    let submit_receiver_value2: any = receiver_value2
      .split(";")
      .map((item: any) => {
        return item.substring(0, item.lastIndexOf("("));
      });

    let submit_receiver_value3: any = receiver_value.split(";");
    let submit_receiver_value4: any = receiver_value2.split(";");

    submit_receiver_value.forEach((item: any) => {
      item == ""
        ? (this.report_settings.notify.email.receiver = submit_receiver_value3)
        : (this.report_settings.notify.email.receiver = submit_receiver_value);
    });
    submit_receiver_value2.forEach((item: any) => {
      item == ""
        ? (this.report_settings.notify.wecom.receiver = submit_receiver_value4)
        : (this.report_settings.notify.wecom.receiver = submit_receiver_value2);
    });

    this.delete_null(tdrAndroidZero_value);
    this.delete_null(threshold_value);
    this.delete_null(riskRule_value);
    // this.delete_null(absRiskRule_value);
    this.delete_null(tdrAndroidFirst_value);
    this.delete_null(tdrAndroidSecond_value);
    this.delete_null(tdrAndroidThird_value);
    this.delete_null(tdrAndroidFourth_value);
    this.delete_null(tdrIosFirst_value);
    this.delete_null(tdrIosSecond_value);
    this.delete_null(tdrIosThird_value);
    this.delete_null(tdrIosZero_value);
    this.delete_null(tdrIosfourth_value);
    this.delete_null(tdrPCZero_value);
    this.delete_null(tdrPCFirst_value);
    this.delete_null(tdrPCSecond_value);
    this.delete_null(tdrPCThird_value);
    this.delete_null(tdrPCfourth_value);
    this.convertNumbers(tdrAndroidFirst_value);
    this.convertNumbers(tdrAndroidZero_value);
    this.convertNumbers(tdrAndroidFourth_value);
    this.convertNumbers(tdrAndroidThird_value);
    this.convertNumbers(tdrAndroidSecond_value);
    this.convertNumbers(tdrIosFirst_value);
    this.convertNumbers(tdrIosSecond_value);
    this.convertNumbers(tdrIosThird_value);
    this.convertNumbers(tdrIosZero_value);
    this.convertNumbers(tdrIosfourth_value);
    this.convertNumbers(tdrPCZero_value);
    this.convertNumbers(tdrPCFirst_value);
    this.convertNumbers(tdrPCSecond_value);
    this.convertNumbers(tdrPCThird_value);
    this.convertNumbers(tdrPCfourth_value);
    this.dataConversion2(threshold_value);
    console.log(this.rule_settings);
    console.log(this.id_list);

    // this.id_list.forEach((v,i)=>{
    //   console.log(222)
    //   console.log(this.rule_settings.tdr_risk_rule[v])
    //   let list=[0,1,2,3,4]
    //   let esList=[]
    //   list.forEach(j=>{
    //   this.convertNumbers(this.rule_settings.tdr_risk_rule[v]?.Android['level_'+j])
    //   this.convertNumbers(this.rule_settings.tdr_risk_rule[v]?.iOS['level_'+j])
    //     esList.push(JSON.stringify(this.rule_settings.tdr_risk_rule[v]?.Android['level_'+j])==="{}")
    //     esList.push(JSON.stringify(this.rule_settings.tdr_risk_rule[v]?.iOS['level_'+j])==="{}")

    //   })
    //   if(esList.every(n=>n==true)){
    //     this.rule_settings.tdr_risk_rule[v].Android=JSON.parse(JSON.stringify(this.rule_settings.tdr_risk_rule.Android))
    //     this.rule_settings.tdr_risk_rule[v].iOS=JSON.parse(JSON.stringify(this.rule_settings.tdr_risk_rule.iOS))
    //     // delete this.rule_settings.tdr_risk_rule[v]

    //   }

    // })
    // this.scene_id=9999
    this.show = false;
    await this.gettdrZeroModel1(this.scene_id);
    await this.gettdrFirstModel1(this.scene_id);
    await this.gettdrSecondModel1(this.scene_id);
    await this.gettdrThirdModel1(this.scene_id);
    await this.gettdrFourthModel1(this.scene_id);
    await this.gettdrIosZeroModel1(this.scene_id);
    await this.gettdrIosFirstModel1(this.scene_id);
    await this.gettdrIosSecondModel1(this.scene_id);
    await this.gettdrIosThirdModel1(this.scene_id);

    await this.gettdrIosfourthModel1(this.scene_id);
    await this.gettdrPcModel1(this.scene_id);
    await this.gettdrPcFirstModel1(this.scene_id);
    await this.gettdrPcSecondModel1(this.scene_id);
    await this.gettdrPcThirdModel1(this.scene_id);
    await this.gettdrPcFourthModel1(this.scene_id);

    this.show = true;

    const Receiver = {
      project_key: readProjectDetail(store).project_key,
      project: this.localProject,
      report_settings: JSON.stringify(this.report_settings),
      rule_settings: JSON.stringify(this.rule_settings),
      is_apply: boolean,
    };

    this.delete_null1(aov_value);
    this.aovNewList(aov_value);
    this.aovNewList(aov3_value);
    if (this.topShow) {
      this.modelList(leve1_value);
      this.modelList(leve2_value);
      this.modelList(leve3_value);
    }

    await dispatchUpdateProject(store, {
      id: readProjectDetail(store).id as number,
      project: Receiver,
    });
    this.dataConversion(threshold_value);
    // this.dataConversion(riskRule_value)
    this.visible = false;
    console.log(this.rule_settings);
    this.loading = false;
  }

  public fixed = false;
}
